import { render, staticRenderFns } from "./record.vue?vue&type=template&id=0585ed4d&scoped=true"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"
import style0 from "./record.vue?vue&type=style&index=0&id=0585ed4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0585ed4d",
  null
  
)

export default component.exports